// import React, { useState, useRef } from "react";
// import { Modal } from "reactstrap";
// import axios from "axios";
// import configure from "configure";

// const GenerateEmailModal = ({ proposalData, rfpData, allEmails }) => {
//   const [emailModal, setEmailModal] = useState(false);
//   const [generatedEmail, setGeneratedEmail] = useState("");
//   const [isGeneratingEmail, setIsGeneratingEmail] = useState(false);
//   // const [copied, setCopied] = useState(false);
//   const [copied, setCopied] = useState({ type: null });
//   const [hasGenerated, setHasGenerated] = useState(false);

//   // Cache key — regenerate only if proposal changes
//   const cachedProposalId = useRef(null);

//   const generateEmail = async (forceRegenerate = false) => {
//     // ── If already generated for this proposal and not forced, just open modal ──
//     if (
//       hasGenerated &&
//       cachedProposalId.current === proposalData?.id &&
//       !forceRegenerate
//     ) {
//       setEmailModal(true);
//       return;
//     }

//     setEmailModal(true);
//     setIsGeneratingEmail(true);
//     setCopied(false);

//     try {
//       const res = await axios.post(
//         `${configure.nodeApi}/generate_proposal_email`,
//         {
//           company_name: proposalData?.companyname || "",
//           contact_name: proposalData?.contactname || "",
//           proposal_title: proposalData?.proposaltitile || "",
//           provider_person: proposalData?.contactmember || "",
//           provider_company: proposalData?.company2 || "Zithas Technologies",
//           provider_email: proposalData?.provideremail || "",
//           provider_phone: proposalData?.contact || "",
//           provider_website: proposalData?.website1 || "",
//           website: proposalData?.website || "",
//           features: rfpData?.features || [],
//           services: rfpData?.services || [],
//           terms: proposalData?.terms || "",
//           currency_symbol: rfpData?.currency_symbol || "",
//           grand_total: rfpData?.grand_total || "",
//           location: proposalData?.location,
//           junk_link: proposalData?.junk_link || "", 
//         },
//         { headers: { "Content-Type": "application/json" } },
//       );

//       if (res.data.success) {
//         setGeneratedEmail(res.data.email);
//         setHasGenerated(true);
//         cachedProposalId.current = proposalData?.id;
//       } else {
//         setGeneratedEmail("Failed to generate email. Please try again.");
//       }
//     } catch (err) {
//       console.error("generateEmail error:", err);
//       setGeneratedEmail("Error generating email. Please try again.");
//     } finally {
//       setIsGeneratingEmail(false);
//     }
//   };

//   // const handleCopy = () => {
//   //   navigator.clipboard.writeText(generatedEmail);
//   //   setCopied(true);
//   //   setTimeout(() => setCopied(false), 2000);
//   // };

//   const copyToClipBoard = async ({ text, setCopy, id }) => {
//   try {
//     await navigator.clipboard.writeText(text);
//     setCopy({ type: id });
//     setTimeout(() => setCopy({ type: null }), 1500);
//   } catch (err) {
//     const textarea = document.createElement("textarea");
//     textarea.value = text;
//     document.body.appendChild(textarea);
//     textarea.select();
//     document.execCommand("copy");
//     document.body.removeChild(textarea);
//     setCopy({ type: id });
//     setTimeout(() => setCopy({ type: null }), 1500);
//   }
// };

//   const handleOpenOutlook = () => {
//     const to = encodeURIComponent(
//       allEmails?.join(";") || proposalData?.email || "",
//     );
//     const subject = encodeURIComponent(
//       proposalData?.proposaltitile || "Proposal",
//     );
//     const body = encodeURIComponent(generatedEmail);
//     window.open(
//       `https://outlook.cloud.microsoft/mail/deeplink/compose?to=${to}&subject=${subject}&body=${body}`,
//       "_blank",
//     );
//   };

//   return (
//     <>
//       {/* Trigger Button — shows indicator if email already cached */}
//       <button
//         className="btn btn-sm btn-outline-success position-relative"
//         title={
//           hasGenerated ? "Email ready — click to view" : "Generate AI Email"
//         }
//         onClick={() => generateEmail(false)}
//       >
//         <i
//           className={`fa ${
//             hasGenerated ? "fa-envelope-open" : "fa-robot"
//           } me-1`}
//         ></i>
//         {hasGenerated ? "View Email" : "Generate Email"}
//         {hasGenerated && (
//           <span
//             className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-success"
//             style={{ fontSize: "8px" }}
//           >
//             ✓
//           </span>
//         )}
//       </button>

//       {/* Email Modal */}
//       <Modal
//         size="lg"
//         centered
//         isOpen={emailModal}
//         toggle={() => setEmailModal(false)}
//       >
//         <div
//           className="modal-header"
//           style={{ borderBottom: "2px solid #5b2d8e" }}
//         >
//           <div className="d-flex align-items-center gap-2">
//             {/* <i
//               className="fa fa-envelope"
//               style={{ color: "#5b2d8e", fontSize: "18px" }}
//             ></i> */}
//             <h5 className="modal-title mt-0 mb-0">AI Generated Email</h5>
//             {hasGenerated && (
//               <span
//                 className="badge ms-2"
//                 style={{
//                   backgroundColor: "#e8f5e9",
//                   color: "#2e7d32",
//                   fontSize: "11px",
//                 }}
//               >
//                 <i className="fa fa-check-circle me-1"></i>Cached
//               </span>
//             )}
//           </div>
//           <button
//             type="button"
//             onClick={() => setEmailModal(false)}
//             className="btn-modal-close ms-auto"
//           >
//             <span aria-hidden="true" className="btn-modal-span">
//               &times;
//             </span>
//           </button>
//         </div>

//         <div className="modal-body" style={{ padding: "20px" }}>
//           {isGeneratingEmail ? (
//             <div className="text-center py-5">
//               <i
//                 className="fa fa-spinner fa-spin fa-2x mb-3"
//                 style={{ color: "#5b2d8e" }}
//               ></i>
//               <p className="text-muted mb-0">
//                 Generating personalised email with AI...
//               </p>
//               <small className="text-muted">This may take a few seconds</small>
//             </div>
//           ) : (
//             <>
//               {/* Subject line preview */}
//               {/* <div
//                 className="mb-3 p-2 rounded d-flex align-items-center gap-2"
//                 style={{
//                   backgroundColor: "#f0ebf8",
//                   border: "1px solid #c8b3e8",
//                 }}
//               >
//                 <span
//                   style={{
//                     fontSize: "12px",
//                     color: "#5b2d8e",
//                     fontWeight: "600",
//                     whiteSpace: "nowrap",
//                   }}
//                 >
//                   SUBJECT:
//                 </span>
//                 <span style={{ fontSize: "13px", color: "#333" }}>
//                   {proposalData?.proposaltitile || "Proposal"} —{" "}
//                   {proposalData?.companyname || ""}
//                 </span>
//               </div> */}
//               {/* Subject card — copyable */}
// <div
//   className="mb-3 p-2 rounded d-flex align-items-center justify-content-between gap-2"
//   style={{ backgroundColor: "#f0ebf8", border: "1px solid #c8b3e8" }}
// >
//   <div className="d-flex align-items-center gap-2">
//     <span style={{ fontSize: "12px", color: "#5b2d8e", fontWeight: "600", whiteSpace: "nowrap" }}>
//       SUBJECT:
//     </span>
//     <span style={{ fontSize: "13px", color: "#333" }}>
//       {proposalData?.proposaltitile || "Proposal"} — {proposalData?.companyname || ""}
//     </span>
//   </div>
//   <div className="d-flex align-items-center gap-1" style={{ flexShrink: 0 }}>
//     {copied.type === "email_subject" && (
//       <span style={{ fontSize: "11px", color: "#2e7d32" }}>Copied</span>
//     )}
//     <i
//       className={`bi ${copied.type === "email_subject" ? "bi-clipboard-check" : "bi-clipboard"} fa-lg`}
//       style={{ cursor: "pointer", color: "#5b2d8e" }}
//       onClick={() => copyToClipBoard({
//         text: `${proposalData?.proposaltitile || "Proposal"} — ${proposalData?.companyname || ""}`,
//         setCopy: setCopied,
//         id: "email_subject",
//       })}
//       title="Copy Subject"
//     />
//   </div>
// </div>

// {/* Editable email body */}
// <div style={{ position: "relative" }}>
//   <textarea
//     style={{
//       backgroundColor: "#fafafa",
//       border: "1px solid #ddd",
//       borderRadius: "6px",
//       padding: "16px 20px",
//       fontFamily: "'Segoe UI', Arial, sans-serif",
//       fontSize: "13.5px",
//       lineHeight: "1.8",
//       color: "#333",
//       width: "100%",
//       minHeight: "380px",
//       resize: "vertical",
//       outline: "none",
//     }}
//     value={generatedEmail}
//     onChange={(e) => setGeneratedEmail(e.target.value)}
//   />
//   {copied.type === "email_body" && (
//     <div className="position-absolute copyMsg" style={{ top: "6px", right: "36px" }}>
//       Copied
//     </div>
//   )}
//   <i
//     className={`position-absolute bi ${copied.type === "email_body" ? "bi-clipboard-check" : "bi-clipboard"} fa-lg`}
//     style={{ top: "8px", right: "15px", cursor: "pointer", color: "#a8a6a6" }}
//     onClick={() => copyToClipBoard({ text: generatedEmail, setCopy: setCopied, id: "email_body" })}
//     title="Click to Copy"
//   />
// </div>

// {/* Action buttons — copy first, then outlook */}
// <div className="d-flex gap-2 mt-3 flex-wrap align-items-center">
//   <button
//     className="btn btn-label"
//     style={{ backgroundColor: "#5b2d8e", color: "#fff" }}
//     onClick={() => copyToClipBoard({ text: generatedEmail, setCopy: setCopied, id: "email_body" })}
//   >
//     <i className={`fa ${copied.type === "email_body" ? "fa-check" : "fa-copy"} me-2 label-icon`}></i>
//     {copied.type === "email_body" ? "Copied!" : "Copy Email"}
//   </button>

//   <button
//     className="btn btn-outline-primary btn-label"
//     onClick={handleOpenOutlook}
//   >
//     <i className="fa fa-envelope me-2 label-icon"></i>
//     Send to Outlook
//   </button>

//   <div className="ms-auto d-flex align-items-center gap-2">
//     <small className="text-muted" style={{ fontSize: "11px" }}>Uses AI tokens</small>
//     <button
//       className="btn btn-outline-danger btn-sm btn-label"
//       onClick={() => {
//         if (window.confirm("Regenerate will use AI tokens. Are you sure?")) {
//           generateEmail(true);
//         }
//       }}
//       disabled={isGeneratingEmail}
//     >
//       <i className="fa fa-refresh me-2 label-icon"></i>
//       Regenerate
//     </button>
//   </div>
// </div>

//               {/* Action buttons */}
//               {/* <div className="d-flex gap-2 mt-3 flex-wrap align-items-center">
//                 <button
//                   className="btn btn-label"
//                   style={{ backgroundColor: "#5b2d8e", color: "#fff" }}
//                   onClick={handleCopy}
//                 >
//                   <i
//                     className={`fa ${copied ? "fa-check" : "fa-copy"} me-2 label-icon`}
//                   ></i>
//                   {copied ? "Copied!" : "Copy Email"}
//                 </button>


//                 <button
//                   className="btn btn-outline-primary btn-label"
//                   onClick={handleOpenOutlook}
//                 >
//                   <i className="fa fa-envelope me-2 label-icon"></i>
//                   Open in Outlook
//                 </button>

//                 <div className="ms-auto d-flex align-items-center gap-2">
//                   <small className="text-muted" style={{ fontSize: "11px" }}>
//                     Uses AI tokens
//                   </small>
//                   <button
//                     className="btn btn-outline-danger btn-sm btn-label"
//                     onClick={() => {
//                       if (window.confirm("Regenerate will use AI tokens. Are you sure?")) {
//                         generateEmail(true);
//                       }
//                     }}
//                     disabled={isGeneratingEmail}
//                     title="Regenerate uses AI tokens"
//                   >
//                     <i className="fa fa-refresh me-2 label-icon"></i>
//                     Regenerate
//                   </button>
//                 </div>
//               </div> */}

//               {/* Editable email body — with copy icon inside */}
//               {/* <div style={{ position: "relative" }}>
//                 <textarea
//                   style={{
//                     backgroundColor: "#fafafa",
//                     border: "1px solid #ddd",
//                     borderRadius: "6px",
//                     padding: "16px 20px",
//                     paddingTop: "40px", // space for copy icon
//                     fontFamily: "'Segoe UI', Arial, sans-serif",
//                     fontSize: "13.5px",
//                     lineHeight: "1.8",
//                     color: "#333",
//                     width: "100%",
//                     minHeight: "380px",
//                     resize: "vertical",
//                     outline: "none",
//                   }}
//                   value={generatedEmail}
//                   onChange={(e) => setGeneratedEmail(e.target.value)}
//                 />
//                 <button
//                   onClick={handleCopy}
//                   title="Copy to clipboard"
//                   style={{
//                     position: "absolute",
//                     top: "8px",
//                     right: "10px",
//                     background: "none",
//                     border: "none",
//                     cursor: "pointer",
//                     color: copied ? "#2e7d32" : "#5b2d8e",
//                     fontSize: "16px",
//                     padding: "2px 6px",
//                     borderRadius: "4px",
//                     transition: "color 0.2s",
//                   }}
//                 >
//                   <i className={`fa ${copied ? "fa-check" : "fa-copy"}`}></i>
//                 </button>
//               </div> */}

//               {/* Editable email body — with copy icon inside */}
// <div style={{ position: "relative" }}>
//   <textarea
//     style={{
//       backgroundColor: "#fafafa",
//       border: "1px solid #ddd",
//       borderRadius: "6px",
//       padding: "16px 20px",
//       fontFamily: "'Segoe UI', Arial, sans-serif",
//       fontSize: "13.5px",
//       lineHeight: "1.8",
//       color: "#333",
//       width: "100%",
//       minHeight: "380px",
//       resize: "vertical",
//       outline: "none",
//     }}
//     value={generatedEmail}
//     onChange={(e) => setGeneratedEmail(e.target.value)}
//   />

//   {/* Copy icon — top right inside textarea */}
//   {copied.type === "email_body" && (
//     <div
//       className="position-absolute copyMsg"
//       style={{ top: "6px", right: "36px" }}
//     >
//       Copied
//     </div>
//   )}
//   <i
//     className={`position-absolute bi ${
//       copied.type === "email_body" ? "bi-clipboard-check" : "bi-clipboard"
//     } fa-lg`}
//     style={{
//       top: "8px",
//       right: "15px",
//       cursor: "pointer",
//       color: "#a8a6a6",
//     }}
//     onClick={() =>
//       copyToClipBoard({
//         text: generatedEmail,
//         setCopy: setCopied,
//         id: "email_body",
//       })
//     }
//     title="Click to Copy"
//   />
// </div>

//               {/* Action buttons */}
//               {/* <div className="d-flex gap-2 mt-3 flex-wrap align-items-center">
//                 <button
//                   className="btn btn-label"
//                   style={{ backgroundColor: "#5b2d8e", color: "#fff" }}
//                   onClick={handleOpenOutlook}
//                 >
//                   <i className="fa fa-envelope me-2 label-icon"></i>
//                   Send to Outlook
//                 </button>

//                 <div className="ms-auto d-flex align-items-center gap-2">
//                   <small className="text-muted" style={{ fontSize: "11px" }}>
//                     Uses AI tokens
//                   </small>
//                   <button
//                     className="btn btn-outline-danger btn-sm btn-label"
//                     onClick={() => {
//                       if (
//                         window.confirm(
//                           "Regenerate will use AI tokens. Are you sure?",
//                         )
//                       ) {
//                         generateEmail(true);
//                       }
//                     }}
//                     disabled={isGeneratingEmail}
//                     title="Regenerate uses AI tokens"
//                   >
//                     <i className="fa fa-refresh me-2 label-icon"></i>
//                     Regenerate
//                   </button>
//                 </div>
//               </div> */}
//             </>
//           )}
//         </div>
//       </Modal>
//     </>
//   );
// };

// export default GenerateEmailModal;



import React, { useState, useRef } from "react";
import { Modal } from "reactstrap";
import axios from "axios";
import configure from "configure";

const GenerateEmailModal = ({ proposalData, rfpData, allEmails }) => {
  const [emailModal, setEmailModal] = useState(false);
  const [generatedEmail, setGeneratedEmail] = useState("");
  const [generatedSubject, setGeneratedSubject] = useState("");
  const [isGeneratingEmail, setIsGeneratingEmail] = useState(false);
  const [copied, setCopied] = useState({ type: null });
  const [hasGenerated, setHasGenerated] = useState(false);

  const cachedProposalId = useRef(null);

  const generateEmail = async (forceRegenerate = false) => {
    if (hasGenerated && cachedProposalId.current === proposalData?.id && !forceRegenerate) {
      setEmailModal(true);
      return;
    }

    setEmailModal(true);
    setIsGeneratingEmail(true);
    setCopied({ type: null });

    try {
      const res = await axios.post(
        `${configure.nodeApi}/generate_proposal_email`,
        {
          company_name: proposalData?.companyname || "",
          contact_name: proposalData?.contactname || "",
          proposal_title: proposalData?.proposaltitile || "",
          provider_person: proposalData?.contactmember || "",
          provider_company: proposalData?.company2 || "Zithas Technologies",
          provider_email: proposalData?.provideremail || "",
          provider_phone: proposalData?.contact || "",
          provider_website: proposalData?.website1 || "",
          website: proposalData?.website || "",
          features: rfpData?.features || [],
          services: rfpData?.services || [],
          terms: proposalData?.terms || "",
          currency_symbol: rfpData?.currency_symbol || "",
          grand_total: rfpData?.grand_total || "",
          location: proposalData?.location,
          junk_link: proposalData?.junk_link || "",
        },
        { headers: { "Content-Type": "application/json" } }
      );

      if (res.data.success) {
        setGeneratedEmail(res.data.email);
        setGeneratedSubject(res.data.subject);
        setHasGenerated(true);
        cachedProposalId.current = proposalData?.id;
      } else {
        setGeneratedEmail("Failed to generate email. Please try again.");
        setGeneratedSubject("");
      }
    } catch (err) {
      console.error("generateEmail error:", err);
      setGeneratedEmail("Error generating email. Please try again.");
      setGeneratedSubject("");
    } finally {
      setIsGeneratingEmail(false);
    }
  };

  const copyToClipBoard = async ({ text, setCopy, id }) => {
    try {
      await navigator.clipboard.writeText(text);
      setCopy({ type: id });
      setTimeout(() => setCopy({ type: null }), 1500);
    } catch {
      const textarea = document.createElement("textarea");
      textarea.value = text;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand("copy");
      document.body.removeChild(textarea);
      setCopy({ type: id });
      setTimeout(() => setCopy({ type: null }), 1500);
    }
  };

  const handleOpenOutlook = () => {
    const to = encodeURIComponent(allEmails?.join(";") || proposalData?.email || "");
    const subject = encodeURIComponent(generatedSubject || proposalData?.proposaltitile || "Proposal");
    const body = encodeURIComponent(generatedEmail);
    window.open(
      `https://outlook.cloud.microsoft/mail/deeplink/compose?to=${to}&subject=${subject}&body=${body}`,
      "_blank"
    );
  };

  return (
    <>
      <button
        className="btn btn-sm btn-outline-success position-relative"
        title={hasGenerated ? "Email ready — click to view" : "Generate AI Email"}
        onClick={() => generateEmail(false)}
      >
        <i className={`fa ${hasGenerated ? "fa-envelope-open" : "fa-robot"} me-1`}></i>
        {hasGenerated ? "View Email" : "Generate Email"}
        {hasGenerated && (
          <span
            className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-success"
            style={{ fontSize: "8px" }}
          >✓</span>
        )}
      </button>

      <Modal size="lg" centered isOpen={emailModal} toggle={() => setEmailModal(false)}>
        <div className="modal-header" style={{ borderBottom: "2px solid #5b2d8e" }}>
          <div className="d-flex align-items-center gap-2">
            <h5 className="modal-title mt-0 mb-0">AI Generated Email</h5>
            {hasGenerated && (
              <span className="badge ms-2" style={{ backgroundColor: "#e8f5e9", color: "#2e7d32", fontSize: "11px" }}>
                <i className="fa fa-check-circle me-1"></i>Cached
              </span>
            )}
          </div>
          <button type="button" onClick={() => setEmailModal(false)} className="btn-modal-close ms-auto">
            <span aria-hidden="true" className="btn-modal-span">&times;</span>
          </button>
        </div>

        <div className="modal-body" style={{ padding: "20px" }}>
          {isGeneratingEmail ? (
            <div className="text-center py-5">
              <i className="fa fa-spinner fa-spin fa-2x mb-3" style={{ color: "#5b2d8e" }}></i>
              <p className="text-muted mb-0">Generating personalised email with AI...</p>
              <small className="text-muted">This may take a few seconds</small>
            </div>
          ) : (
            <>
              {/* AI-generated Subject card */}
              <div
                className="mb-3 p-2 rounded d-flex align-items-center justify-content-between gap-2"
                style={{ backgroundColor: "#f0ebf8", border: "1px solid #c8b3e8" }}
              >
                <div className="d-flex align-items-center gap-2 flex-grow-1">
                  <span style={{ fontSize: "12px", color: "#5b2d8e", fontWeight: "600", whiteSpace: "nowrap" }}>
                    SUBJECT:
                  </span>
                  <input
                    type="text"
                    value={generatedSubject}
                    onChange={(e) => setGeneratedSubject(e.target.value)}
                    style={{
                      fontSize: "13px",
                      color: "#333",
                      background: "transparent",
                      border: "none",
                      outline: "none",
                      width: "100%",
                    }}
                  />
                </div>
                <div className="position-relative d-flex align-items-center">
                  {copied.type === "subject" && (
                    <span className="position-absolute copyMsg" style={{ right: "24px", whiteSpace: "nowrap" }}>
                      Copied
                    </span>
                  )}
                  <i
                    className={`bi ${copied.type === "subject" ? "bi-clipboard-check" : "bi-clipboard"} fa-lg`}
                    style={{ cursor: "pointer", color: "#a8a6a6" }}
                    onClick={() => copyToClipBoard({ text: generatedSubject, setCopy: setCopied, id: "subject" })}
                    title="Copy subject"
                  />
                </div>
              </div>

              {/* Editable email body */}
              <div style={{ position: "relative" }}>
                <textarea
                  style={{
                    backgroundColor: "#fafafa",
                    border: "1px solid #ddd",
                    borderRadius: "6px",
                    padding: "16px 40px 16px 20px",
                    fontFamily: "'Segoe UI', Arial, sans-serif",
                    fontSize: "13.5px",
                    lineHeight: "1.8",
                    color: "#333",
                    width: "100%",
                    minHeight: "380px",
                    resize: "vertical",
                    outline: "none",
                  }}
                  value={generatedEmail}
                  onChange={(e) => setGeneratedEmail(e.target.value)}
                />
                {copied.type === "email_body" && (
                  <div className="position-absolute copyMsg" style={{ top: "6px", right: "36px" }}>Copied</div>
                )}
                <i
                  className={`position-absolute bi ${copied.type === "email_body" ? "bi-clipboard-check" : "bi-clipboard"} fa-lg`}
                  style={{ top: "8px", right: "12px", cursor: "pointer", color: "#a8a6a6" }}
                  onClick={() => copyToClipBoard({ text: generatedEmail, setCopy: setCopied, id: "email_body" })}
                  title="Copy email body"
                />
              </div>

              {/* Action buttons */}
              <div className="d-flex gap-2 mt-3 flex-wrap align-items-center">
                {/* Copy button first */}
                {/* <button
                  className="btn btn-label"
                  style={{ backgroundColor: "#5b2d8e", color: "#fff" }}
                  onClick={() => copyToClipBoard({ text: generatedEmail, setCopy: setCopied, id: "email_btn" })}
                >
                  <i className={`fa fa-lg me-2 label-icon`}></i>
                  {copied.type === "email_btn" ? "Copied!" : "Copy Email"}
                </button> */}
                <div className="position-relative d-flex align-items-center me-1">
  {copied.type === "email_body" && (
    <span className="position-absolute copyMsg" style={{ right: "24px", whiteSpace: "nowrap" }}>
      Copied
    </span>
  )}
  <i
    className={`bi ${copied.type === "email_body" ? "bi-clipboard-check" : "bi-clipboard"} fa-lg`}
    style={{ cursor: "pointer", color: "#5b2d8e", fontSize: "18px" }}
    onClick={() => copyToClipBoard({ text: generatedEmail, setCopy: setCopied, id: "email_body" })}
    title="Copy email body"
  />
</div>

                {/* Send to Outlook */}
                <button className="btn btn-outline-primary btn-label" onClick={handleOpenOutlook}>
                  <i className="fa fa-envelope me-2 label-icon"></i>
                  Send to Outlook
                </button>

                {/* Regenerate */}
                <div className="ms-auto d-flex align-items-center gap-2">
                  <small className="text-muted" style={{ fontSize: "11px" }}>Uses AI tokens</small>
                  <button
                    className="btn btn-outline-danger btn-sm btn-label"
                    onClick={() => {
                      if (window.confirm("Regenerate will use AI tokens. Are you sure?")) {
                        generateEmail(true);
                      }
                    }}
                    disabled={isGeneratingEmail}
                  >
                    <i className="fa fa-refresh me-2 label-icon"></i>
                    Regenerate
                  </button>
                </div>
              </div>
            </>
          )}
        </div>
      </Modal>
    </>
  );
};

export default GenerateEmailModal;